import React from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import SectionLoader from "~/components/SectionLoader/SectionLoader";
import { FETCH_ACCOUNT_SETTINGS_SUCCESS } from "~/store/action_types";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const APP_SUMO_PLANS = ["app_sumo_tier_1", "app_sumo_tier_2", "app_sumo_tier_3"];

export const ForbiddenAccessForAppSumo = ({ children, redirectTo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, isFetched, data } = useQuery(
    "account-settings",
    () =>
      fetch({
        url: `${Angie.api_url}/account-settings`,
      }),
    {
      onSuccess: (response) => {
        dispatch({
          type: FETCH_ACCOUNT_SETTINGS_SUCCESS,
          response,
        });
        if (Array.isArray(response) && response.length === 0) {
          return navigate(redirectTo);
        }
      },
    }
  );

  if (isLoading) {
    return <SectionLoader />;
  }

  if (isFetched) {
    if (
      data &&
      data.status &&
      !data.status.is_cancelled &&
      !data.status.is_retired &&
      (data.status.is_trial || (data.plan && !APP_SUMO_PLANS.includes(data.plan?.name.toLowerCase())))
    ) {
      return children;
    }
  }

  return <Navigate to={redirectTo} />;
};

ForbiddenAccessForAppSumo.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

ForbiddenAccessForAppSumo.defaultProps = {
  redirectTo: "/not-found",
};
